module.exports = __webpack_public_path__ + "static/services4-e82e078d073b3a8f2b6391b32b2b3813.jpg";